import React, { useState, useEffect, useRef } from "react";
import { PDFViewer as PaperviewPDF } from "@paperviewpdf/react-viewer";
import httpClient from "../../lib/HttpClient";
import axiosClient, { loadDocumentUrl } from "../../lib/axios-client";
import download from "downloadjs";
import security from "../../services/Security";
import { Col } from "react-grid-system";
import VideoApp from "../Video/VideoApp";
import accountSetting from "../../services/AccountSetting";

import DownloadSVG from "../../images/icons/svg/share-link-download-mobile.svg";
import OopsImage from "../../images/icons/svg/oops-image.svg";
import styles from "./ShareLinkViewer.module.scss";

var ShareLinkViewer = function (props) {
  var hashUrl = props.match.params.hash_url;

  var [video, setVideo] = useState(null);
  var [documentDetails, setDocumentDetails] = useState(null);
  var [documentUrl, setDocumentUrl] = useState(null);
  var [error, setError] = useState(false);
  var [duration, setDuration, durationRef] = useStateRef(0);
  var [intervalId, setIntervalId] = useState(null);
  var [sessionId] = useState(
    Array(32)
      .fill(0)
      .map(function () {
        return Math.random().toString(36)[2];
      })
      .join("")
  );

  var documentContainer = null;

  var handleVisibilityChange = function () {
    if (document.visibilityState === "hidden") {
      httpClient.put("/share_links/session/duration", {
        hash_url: hashUrl,
        session_id: sessionId,
        duration: durationRef.current,
      });
      setDuration(0);
      clearInterval(intervalId);
    } else {
      var id = setInterval(function () {
        setDuration(function (prevDuration) {
          return prevDuration + 1;
        });
      }, 1000);
      setIntervalId(id);
    }
  };

  var beforeunload = function () {
    httpClient.put("/share_links/session/duration", {
      hash_url: hashUrl,
      session_id: sessionId,
      duration: durationRef.current,
    });
  };

  /**
   * Downloads the PDF document via the share link download endpoint.
   * Posts to the backend which logs the download event for analytics,
   * then triggers a browser file download with the response data.
   */
  var downloadDoc = function () {
    if (!documentDetails) return;
    var url = "/share_links/download";
    var title = documentDetails.title + documentDetails.file_extension;
    var type = documentDetails.mime_type;
    var token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: "Bearer " + token },
      data: {
        hash_url: hashUrl,
        session_id: sessionId,
      },
    }).then(function (response) {
      download(response.data, title, type);
    });
  };

  /**
   * Downloads the video file. First posts to the share link download
   * endpoint to log the event, then fetches the actual video file
   * from its download URL.
   */
  var downloadVideoFile = function () {
    var url = "/share_links/download";
    var token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: "Bearer " + token },
      data: {
        hash_url: hashUrl,
        session_id: sessionId,
        video_download: true,
      },
    });

    axiosClient({
      method: "get",
      url: video.video_download_url,
      responseType: "arraybuffer",
    }).then(function (response) {
      download(response.data, video.video_file_name);
    });
  };

  useEffect(function () {
    httpClient
      .get(loadDocumentUrl() + "/share_links/view/" + hashUrl)
      .then(function (res) {
        if (res.data.video_document) {
          setVideo(res.data.video_document);

          httpClient.post("/share_links/session/create.json", {
            hash_url: hashUrl,
            session_id: sessionId,
          });

          var counterInterval = setInterval(function () {
            setDuration(function (prevDuration) {
              return prevDuration + 1;
            });
          }, 1000);
          setIntervalId(counterInterval);

          document.addEventListener("visibilitychange", handleVisibilityChange);
          document.addEventListener("beforeunload", beforeunload);
        } else {
          // PDF document — set URL for PaperView PDF component
          setDocumentUrl(loadDocumentUrl() + "/share_links/view/" + hashUrl);

          // Create session to log the view and get document details
          httpClient
            .post("/share_links/session/create.json", {
              hash_url: hashUrl,
              session_id: sessionId,
            })
            .then(function (response) {
              setDocumentDetails(response.data);
            });

          var counterInterval = setInterval(function () {
            setDuration(function (prevDuration) {
              return prevDuration + 1;
            });
          }, 1000);
          setIntervalId(counterInterval);

          document.addEventListener("beforeunload", beforeunload);
          document.addEventListener("visibilitychange", handleVisibilityChange);
        }
      })
      .catch(function () {
        setError(true);
      });

    return function () {
      window.removeEventListener("beforeunload", beforeunload);
    };
  }, []);

  return (
    <div className={styles.container} id="document_container">
      {!error && (
        <React.Fragment>
          <div id="usersScreenHeader">
            {accountSetting.getSetting("sharelink:whitelabel:logo:url") && (
              <img
                src={accountSetting.getSetting("sharelink:whitelabel:logo:url")}
              />
            )}
          </div>
          <div className={styles.headerContainer}>
            <div className={styles.header} id="document_view_header">
              {video && video.document_title}
              {!video && documentDetails && documentDetails.title}
            </div>
            {video && (
              <React.Fragment>
                <button
                  className={styles.downloadButtonDesktop}
                  onClick={downloadVideoFile}
                >
                  Download
                </button>
                <div
                  className={styles.downloadButtonMobile}
                  onClick={downloadVideoFile}
                >
                  <img src={DownloadSVG} />
                </div>
              </React.Fragment>
            )}
            {!video && documentDetails && (
              <React.Fragment>
                <button
                  className={styles.downloadButtonDesktop}
                  onClick={downloadDoc}
                >
                  Download
                </button>
                <div
                  className={styles.downloadButtonMobile}
                  onClick={downloadDoc}
                >
                  <img src={DownloadSVG} />
                </div>
              </React.Fragment>
            )}
          </div>
          {video && (
            <React.Fragment>
              <Col
                sm={9}
                className={styles.documentContainer}
                ref={function (element) {
                  documentContainer = element;
                }}
                id="document_container"
              >
                <VideoApp doc={video} documentContainer={documentContainer} />
              </Col>
            </React.Fragment>
          )}
          {!video && documentUrl && (
            <div className={styles.webViewerContainer}>
              <PaperviewPDF
                style={{ width: "100%", height: "100%" }}
                onError={function () {
                  setError(true);
                }}
                config={{
                  src: documentUrl,
                  wasmUrl: "/pdfium.wasm",
                  worker: true,
                  theme: {
                    preference: "light",
                  },
                  disabledCategories: [
                    "annotation",
                    "redaction",
                    "selection",
                    "history",
                    "tools",
                    "mode-annotate",
                    "mode-shapes",
                    "mode-redact",
                    "document",
                    "panel-comment",
                  ],
                }}
              />
            </div>
          )}
        </React.Fragment>
      )}
      {error && (
        <div className={styles.errorState}>
          <div className={styles.text}>
            <div className={styles.header}>oops!</div>
            <div className={styles.text}>
              Looks like this link no longer exists
            </div>
          </div>
          <div className={styles.image}>
            <img src={OopsImage} />
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * Custom hook that combines useState with a ref that stays in sync.
 * The ref always holds the latest value, useful for accessing current
 * state inside closures (e.g. event handlers, timers) that would
 * otherwise capture a stale value.
 */
var useStateRef = function (initialValue) {
  var [value, setValue] = useState(initialValue);
  var ref = useRef(value);

  useEffect(
    function () {
      ref.current = value;
    },
    [value]
  );

  return [value, setValue, ref];
};

export default ShareLinkViewer;
